import React, { useState } from "react";
import { Box, Typography, Card, Button, IconButton, TextField, Divider } from "@mui/material";
import { CalendarToday as CalendarTodayIcon, Edit as EditIcon, Delete as DeleteIcon, ChatBubbleOutline as ChatBubbleOutlineIcon } from "@mui/icons-material";
import ImageSlider from "./ImageSlider";

export default function SingleBlogPost({ post, canEdit, isAdmin, userId, token, onBack, onEdit, onDelete, onAddComment, onDeleteComment, onImageClick, themeConfig }) {
  const [commentText, setCommentText] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmitComment = async () => {
    if (!commentText.trim()) return;
    setSubmitting(true);
    await onAddComment(commentText);
    setCommentText("");
    setSubmitting(false);
  };

  return (
    <Box style={{ maxWidth: "800px", margin: "0 auto" }}>
      <Button onClick={onBack} style={{ textTransform: "none", marginBottom: "16px", color: themeConfig.buttonColor, fontWeight: 700 }}>
        ← Back to all stories
      </Button>
      <Card elevation={0} style={{ backgroundColor: "#ffffff", borderRadius: "14px", border: "1px solid #e0e0e0", overflow: "hidden", padding: "24px" }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="h5" style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800, color: "#1a1a1a", marginBottom: "8px" }}>
            {post.title}
          </Typography>
          {canEdit && (
            <Box display="flex" gap={1}>
              <IconButton size="small" onClick={() => onEdit(post)}><EditIcon fontSize="small" /></IconButton>
              <IconButton size="small" color="error" onClick={() => onDelete(post.id)}><DeleteIcon fontSize="small" /></IconButton>
            </Box>
          )}
        </Box>
        <Box display="flex" alignItems="center" gap={1} style={{ color: "#888", fontSize: "0.85rem", marginBottom: "16px" }}>
          <CalendarTodayIcon style={{ fontSize: "0.9rem" }} />
          <span>{new Date(post.created_on).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</span>
          <span>
            • Written by {post.author_is_admin || post.author_name === "Social Creds" || post.author_name === "Admin User" || post.author_name === "admin" || !post.author_name ? "admin" : post.author_name}
          </span>
        </Box>
        {post.images && post.images.length > 0 && (
          <Box style={{ marginBottom: "20px" }}>
            <ImageSlider images={post.images} alt={post.title} height="360px" onImageClick={(idx) => onImageClick(post.images, idx, post.title)} />
          </Box>
        )}
        <Typography variant="body1" style={{ fontFamily: "'Raleway', sans-serif", lineHeight: 1.7, color: "#222", whiteSpace: "pre-line", textAlign: "justify" }}>
          {post.content}
        </Typography>

        {/* Comments Section */}
        <Divider style={{ margin: "32px 0 20px 0" }} />
        <Typography variant="h6" style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 700, marginBottom: "16px", display: "flex", alignItems: "center", gap: "8px" }}>
          <ChatBubbleOutlineIcon /> Comments ({post.comments?.length || 0})
        </Typography>

        {post.comments?.map((c) => (
          <Box key={c.id} style={{ backgroundColor: "#f7f7f7", borderRadius: "10px", padding: "12px 16px", marginBottom: "12px" }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle2" style={{ fontWeight: 700, color: "#333" }}>{c.author_name}</Typography>
              {(isAdmin || c.user === userId || post.author_id === userId) && (
                <IconButton size="small" color="error" onClick={() => onDeleteComment(c.id)}><DeleteIcon fontSize="inherit" /></IconButton>
              )}
            </Box>
            <Typography variant="body2" style={{ marginTop: "4px", color: "#444" }}>{c.content}</Typography>
          </Box>
        ))}

        {token ? (
          <Box display="flex" gap={1.5} mt={2}>
            <TextField fullWidth size="small" placeholder="Write a comment..." value={commentText} onChange={(e) => setCommentText(e.target.value)} />
            <Button variant="contained" disabled={submitting || !commentText.trim()} onClick={handleSubmitComment} style={{ backgroundColor: themeConfig.buttonColor, color: themeConfig.buttonFontColor, textTransform: "none", borderRadius: "8px", fontWeight: 700 }}>
              Post
            </Button>
          </Box>
        ) : (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: "12px" }}>Log in to leave a comment.</Typography>
        )}
      </Card>
    </Box>
  );
}
